import Stack from '../Stack';
import Box from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";

function Container(props) {
  return _jsx(Stack, {
    justifyContent: "center",
    children: _jsx(Box, {
      width: [1, 10 / 12, 8 / 12],
      px: ['28px', '48px', '62px'],
      children: props.children
    })
  });
}

Container.defaultProps = {};
Container.displayName = 'Container';
export default Container;